export enum HubMethods {
    RetrieveCurrentCall = 'retrieveCurrentCall',
    OnCurrentCall = 'onCurrentCall',
    CreateMeeting = 'createMeeting',
    OnCallStatus = 'onCallStatus',
    InviteToCurrentCall = 'inviteToCurrentCall',
    EndCurrentCall = 'endCurrentCall',
    RetrieveChat = 'retrieveChat',
    OnChat = 'onChat',
    UpdateChat = 'updateChat',
    SendChatMessage = 'sendChatMessage',
    OnChatMessage = 'onChatMessage',
    ListChatMessages = 'listChatMessages',
    OnChatMessageList = 'onChatMessageList',
    DeleteChatMessage = 'deleteChatMessage',
}
